import { render, staticRenderFns } from "./libraryEditForm.vue?vue&type=template&id=4b4e4c1c"
import script from "./libraryEditForm.vue?vue&type=script&lang=js"
export * from "./libraryEditForm.vue?vue&type=script&lang=js"
import style0 from "./libraryEditForm.vue?vue&type=style&index=0&id=4b4e4c1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports